<template>
  <div class="UphotoShow">
    <div class="contentWidth">

      <!-- <div class="bd of_h"> -->
      <Loading :loading_bool="loading_bool"></Loading>
      <!-- </div> -->

      <div class="bd of_h"
           v-if="!loading_bool && own_photo_data.length!==0">
        <ul class="clearFix">
          <li class="fc_l"
              v-for="(item,index) in own_photo_data"
              :key="index">
            <div class="image">
              <img :src="item.coverUrl"
                   :alt="item.comments"
                   @click="addwork(item.photoshowId)"
                   class="cover_img"
                   v-if="item.coverUrl && item.coverUrl !==''">

              <img src="@/assets/image/common/null_cover.png"
                   :alt="item.title"
                   @click="addwork(item.photoshowId)"
                   class="null_cover_img"
                   v-else>

              <div class="btn of_h">
                <!-- <a href="#"
                   v-if="item.status==0"
                   class="fc_l">审核中</a>
                <a href="#"
                   v-if="item.status==1"
                   class="fc_l">审核通过</a>
                <a href="#"
                   v-if="item.status==2"
                   class="fc_l">已下线</a>
                <a href="#"
                   :title="item.option"
                   v-if="item.status==3"
                   class="fc_l">{{status_type}}</a> -->
                <el-popconfirm title="您确定删除吗？" @confirm="remove(item.photoshowId)">
                  <el-button slot="reference" icon="el-icon-delete">删除</el-button>
                </el-popconfirm>
                
                <el-popover
                  placement="bottom"
                  trigger="click"
                  :visible-arrow="true"
                  popper-class="photo-show-share"
                  width="120"
                  v-if="item.status==1"
                >
                  <div class="share" id="share">
                    <a href="javascript:;"
                      @click="share_qq(index)"
                      target="_blank"><i class="fa fa-qq"></i>QQ</a>
                    <a href="javascript:;"
                      @click="share_wb(index)"><i class="fa fa-weibo"></i>微博</a>
                    <a href="javascript:;"
                      class="sharewb">
                      <i class="fa fa-weixin"></i>微信
                    </a>
                    <div class="wecodeSp"
                          :id="`qrcodes${index}`"
                          :ref="`qrcodeContainers${index}`"
                      >
                    </div>
                  </div>
                  <el-button class="share-btn" slot="reference" icon="el-icon-share" @click.stop="shareClick(index)">分享</el-button>
                </el-popover>
              

              </div>

            </div>
            <div class="photo-show-info">
              <div class="name mt_5"><span :title="item.title">{{item.title}}</span> <i v-if="item.status!=1">（{{item.status|workStatus}}）</i></div>
              <div class="time" v-if="item.createTime">{{item.createTime.substring(0,10)}}</div>
            </div>
            <div class="listtag"
                 v-if="item.workCount!==0">{{item.workCount}}</div>

          </li>

        </ul>

      </div>

      <div class="null_data"
           v-if="own_photo_data.length ==0">
        <img src="@/assets/image/common/null_data.png"
             alt="">
        <p>暂无影展...</p>
      </div>

      <div class="UphotoShowpage">
        <el-pagination background
                       :hide-on-single-page="true"
                       layout="prev, pager, next"
                       :current-page="page.current_page"
                       @current-change="handleCurrentChange_own"
                       :page-size="page.PageSize"
                       :total="page.total"></el-pagination>
      </div>
    </div>

    <!--创建影展-->
    <div class="addyzbg"
         v-show="panelShow ==true">
      <div class="addyz">
        <div class="hd of_h">

          <h3>创建影展</h3>
          <button class="fc_r"
                  @click="closedyz()">×</button>
        </div>
        <div class="addyz_bd pd_15">
          <div class="title"><span>*</span>标题</div>
          <div class="entry tag">
            <input type="text"
                   @input="get_last_title()"
                   v-model="create_photo.title"
                   class=""><span>{{20 - create_photo.title.length}}</span>
          </div>
          <div class="title">描述</div>
          <div class="entry ">
            <textarea v-model="create_photo.comments"></textarea>
          </div>
          <div class="title"><span>*</span>权限</div>
          <div class="entry">
            <label v-for="(item,index) in label"
                   :key="index">
              <input type="radio"
                     :value="item.value"
                     @change="handle()"
                     v-model="create_photo.label"><span>{{item.name}}</span></label>
          </div>
        </div>
        <div class="addyzfoot of_h">
          <button @click="me_save_photo(1)"
                  :disabled="isDisable"
                  class="fc_r sure">确定</button>

          <button @click="closedyz()"
                  class="fc_r">取消</button>

        </div>
      </div>
    </div>
    <!-- 编辑影展 -->
    <div class="addyzbg"
         v-show="panelShow2 == true">
      <div class="addyz">
        <div class="hd of_h">
          <h3>编辑影展</h3>
          <button class="fc_r"
                  @click="closedyz2()">×</button>
        </div>
        <div class="addyz_bd pd_15">
          <div class="title"><span>*</span>标题</div>
          <div class="entry tag">
            <input type="text"
                   @input="get_last_title()"
                   v-model="create_photo.title"
                   class=""><span>{{20 - create_photo.title.length}}</span>
          </div>

          <div class="title">描述</div>
          <div class="entry ">
            <textarea v-model="create_photo.comments"></textarea>
          </div>
          <div class="title"><span>*</span>权限</div>
          <div class="entry">
            <label v-for="(item,index) in label"
                   :key="index">
              <input type="radio"
                     :value="item.value"
                     @change="handle()"
                     v-model="create_photo.label"><span>{{item.name}}</span></label>
          </div>
        </div>
        <div class="addyzfoot of_h">
          <button @click="me_save_photo(2)"
                  :disabled="isDisable"
                  class="fc_r sure">确定</button>
          <button @click="closedyz2()"
                  class="fc_r">取消</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Loading from '@/components/loading/loading.vue'
import { me_photo, save_photo, deletePhotoShow, editPhotoSave, updatePhoto } from '@/utils/api/ucenter.js'//影展

export default {
  name: "UphotoShow",
  // inject: ['reload'],

  props: {
    panelShow: {
      type: Boolean,

    }
  },
  beforeCreated () {
    that = this;

  },
  filters: {
    workStatus: function (value) {
      if (value == 0) {
        return '审核中'
      } else if (value == 1) {
        return '审核通过'
      } else if (value == 2) {
        return '已下线'

      } else if (value == 3) {
        return that.status_type
      }
    }


  },
  data () {
    return {
      status_type: '',//审核状态
      loading_bool: true,//加载loading
      own_photo_data: [],//影展信息
      page: {
        total: 0,
        current_page: 1,//默认第一页
        PageSize: 10,
      },

      // 创建的数据  
      label: [
        { value: 1, name: '公开' },
        { value: 2, name: '仅自己可见' }
      ],
      own_save_photo: [],//创建的影展
      create_photo: {
        title: '',//标题
        comments: '',//简介
        label: '',//权限
      },

      isDisable: false,//防止重复提交
      panelShow2: false,
      photoshowId: '',//编辑的id
      // 分享
      share: {},

    }
  },
  created () {
    let params = {
      current: 1,
      size: 10,
    }
    this.own_photo(params);//影展列表
  },
  methods: {
    //自己影展数据
    own_photo (name) {
      this.loading_bool = true;
      me_photo(name).then((res) => {
        let data = res.data;
        this.own_photo_data = data.data.records
        this.$nextTick(() => {
          // let query = JSON.parse(JSON.stringify(this.$route.query))
          // document.title = '中经视觉-' + this.photo_data[query.step].title
          this.own_photo_data.map((i, k) => {
            this.showQRCodes('qrcodes'+k, k);
          })
        })
        // 分页
        this.page.total = data.total; //全部数据
        this.page.current_page = data.current; //默认第一页
        this.page.PageSize = data.size //每页条数

        if (this.own_photo_data.status == 0) {
          this.status_type = '审核中'
        } else if (this.own_photo_data.status == 1) {
          this.status_type = '审核通过'
        } else if (this.own_photo_data.status == 2) {
          this.status_type = '已下线'
        } else {
          this.status_type = '审核未通过'
        }
        this.loading_bool = false;
        this.$emit('update_data', true)//传父组件 让腹组件更新导航数据
      })
        // this.getSocialShareUrls();  
    },

    // 点击分页
    handleCurrentChange_own (val) {
      let params = {
        current: val,
        size: 10,
      }
      this.own_photo(params)
    },

    // 接受父组件过来的方法
    sonFun (param) {
      // console.log(this.panelShow)
      // console.log(param)
    },
    // 监听截取字符
    get_last_title () {
      if (this.create_photo.title.length >= 20) {
        this.create_photo.title = this.create_photo.title.substr(0, 20);
      }
    },

    // 关闭创建的弹窗    
    closedyz () {
      this.$emit('update:panelShow', !this.panelShow)
      // 关闭后清空 
      this.create_photo.title = ""
      this.create_photo.comments = ""
      this.create_photo.label = ""
    },


    // 点击权限
    handle () {
      // console.log(this.create_photo.label);
    },


    // 删除
    remove (id) {
      let params = {
        photoShowId: id
      }
      deletePhotoShow(params).then((res) => {
        let data = res.data;

        let params2 = {
          current: 1,
          size: 10,
        }
        this.own_photo(params2);//影展列表
      })
    },


    //创建影展 新建和编辑的保存
    me_save_photo (index) {
      // 防止重复点击  时间1s
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false
      }, 1000)

      if (this.create_photo.title.length == 0) {
        this.$message.error('请输入标题');
        return;
      }
      if (this.create_photo.comments.length == 0) {
        this.$message.error('请输入简介');
        return;
      }
      if (this.create_photo.label.length == '') {
        this.$message.error('请选择权限');
        return;
      }


      if (index == 1) {
        let params = {
          title: this.create_photo.title,
          comments: this.create_photo.comments,
          authority: this.create_photo.label,
        }
        save_photo(params).then((res) => {
          let data = res.data;
          this.own_save_photo = data.data
          this.$emit('update:panelShow', !this.panelShow)

          let params2 = {
            current: 1,
            size: 10,
          }
          this.own_photo(params2);//影展列表

        })
      } else {
        // edit(Id, comments, title, authority) {
        // this.$emit('update:panelShow', !this.panelShow)
        let params = {
          title: this.create_photo.title,
          comments: this.create_photo.comments,
          authority: this.create_photo.label,
          photoshowId: this.photoshowId,
        }
        return false
        editPhotoSave(params).then((res) => {
          let data = res.data;
          console.log(data);
          this.panelShow2 = false

          let params2 = {
            current: 1,
            size: 10,
          }
          this.own_photo(params2);//影展列表
        })
      }
    },


    // 关闭创建的弹窗    
    closedyz2 () {
      // this.$emit('update:panelShow', !this.panelShow)
      this.panelShow2 = false
    },
    // 编辑
    edit_from (id, comments, title, authority) {
      this.create_photo.title = title
      this.create_photo.comments = comments
      this.create_photo.label = authority
      this.photoshowId = id
      this.panelShow2 = true
    },

    // 点击封面进入上传
    addwork (id) {
      this.$router.push({
        path: '/Puploadfile',
        query: {
          photoshowId: id,
        }
      })
    },
    // 生成为二维码
    showQRCodes (id, ind) {
      let that = this;
      setTimeout(() => {
        this.url = 'https://v.jingjiribao.cn/newcommunity' +'#' + `/PhotoShow?userId=${that.own_photo_data[ind].userId}&step=${ind}`
        let qrcode = new this.$QRCode(id, {
          text: this.url, //当前地址栏完整参数
          width: 100,
          height: 100,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: this.$QRCode.CorrectLevel.H
        });
      }, 1000);
    },
    //  分享到qq
    share_qq (ind) {
      const share = {
        title: this.own_photo_data[ind].title,
        desc: this.own_photo_data[ind].comments,
        share_url: window.location.href,
      };
      window.open("https://connect.qq.com/widget/shareqq/index.html?url=" + encodeURIComponent(share.share_url) + "&title=" + share.title + "&desc=" + share.desc);
    },

    //  分享到微博
    share_wb (ind) {
      const share = {
        title: this.own_photo_data[ind].title,
        desc: this.own_photo_data[ind].comments,
        share_url: window.location.href,
      };
      window.open('https://service.weibo.com/share/share.php?url=' + encodeURIComponent(share.share_url) + '&title=' + share.title + '&pic=' + share.image_url + '&searchPic=true');
    },
    shareClick (ind) {
      document.title = '中经视觉-' + this.own_photo_data[ind].title
    }

  },
  components: { Loading },

}
</script>
<style >
.el-button--primary {
  color: #fff !important;
  background-color: #d4011a;
  border-color: #d4011a;
}
</style>

<style lang="scss" scoped="scoped">
>>> .el-button:focus,
.el-button:hover {
  background: none !important;
}
>>>.el-button:hover i,>>>.el-button:hover span{
   color: #d4011a;
  //  transition: all 1s;

}

.bd ul li:nth-child(4n) {
  margin-right: 0 !important;
}

>>> .el-button {
  height: 40px;

  // float: right;
  border: none;
  background: none;
}
>>> .el-button span,>>> .el-button i {
  font-size: 14px;
  color: #fff;
  font-weight: 0;
}

div.UphotoShow {
  div.contentWidth {
    margin: 0 auto;
    // margin-top: 20px;
    // margin-bottom: 20px;
    // padding-bottom: 20px;
    border-radius: 10px;
    div.bd {
      padding: 0 20px;
      padding-bottom: 20px;
      min-height: 500px;
      ul {
        width: 100%;
        margin-top: 5px;
        padding-bottom: 20px;
        li {
          width: 300px;
          margin-top: 30px;
          border-radius: 10px;
          // padding: 10px;
          // background: url(../../assets/image/community/imgbg.png) center 200px
          //   no-repeat #fff;
          // border: 1px #f1f1f1 solid;
          margin-right: 20px;
          cursor: pointer;
          position: relative;
          transition: all 1s;
          &:hover {
            // box-shadow: 0px 5px 20px rgba(245, 183, 183, 0.2);
          }
          &:hover .btn {
            top: 165px;
          }
          div.image {
            width: 100%;
            height: 206px;
            // background: url(../../assets/image/community/imgbg.png) center
            //   bottom no-repeat #fff;
            position: relative;
            overflow: hidden;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .cover_img {
            display: block;
            width: 100%;
            height: 200px;
            object-fit: cover;
            border-top-left-radius: 4px;
            border-top-right-radius: 4px;
          }
          .cover_img:hover {
            opacity: 0.8;
            transition: all 0.1s linear 0s;
          }
          .null_cover_img {
            width: 100px;
            height: 100px;
          }
          .photo-show-info {
            background: rgb(255, 255, 255);
            border-bottom: 1px solid rgb(238, 238, 238);
            padding: 5px 16px 10px;
            border-bottom-right-radius: 4px;
            border-bottom-left-radius: 4px;
          }
          div.name,
          div.time {
            height: 20px;
            line-height: 20px;
            font-size: 14px;
            display: inline-block;
            width: 100%; 
            display: flex;
            // justify-content: space-between;
           
            span {
              max-width: calc(100% - 60px);
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap; 
              display: inline-block;
            }
            i{
              color: #c1c1c1;
              // font-style: italic;
              color: rgb(187, 187, 187);
              display: inline-block;
              max-width: 120px;
              font-size: 12px;
            }
          }
          div.time {
            font-family: "PingFang SC", "Lantinghei SC", "Microsoft YaHei",
              "HanHei SC", "Helvetica Neue", "Open Sans", Arial,
              "Hiragino Sans GB", "微软雅黑", STHeiti, "WenQuanYi Micro Hei",
              SimSun, sans-serif;
            margin-top: 3px;
            color: rgb(187, 187, 187);
            font-size: 12px;
          }
          div.listtag {
            width: 20px;
            height: 37px;
            padding: 6px 0 0 24px;
            color: #fff;
            font-size: 16px;
            font-weight: bold;
            position: absolute;
            top: 3px;
            right: 0px;
            background: url(../../assets/image/community/listtag.png) no-repeat;
            border-top-right-radius:4px;
          }
          div.btn {
            position: absolute;
            // top: 206px;
            top: 165px;
            width: 100%;
            height: 40px;
            transition: all 0.3s;
            background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.8));
            display: flex;
            align-items: center;
            justify-content: space-between;
            a {
              display: inline-block;
              height: 40px;
              line-height: 40px;
              font-size: 14px;
              color: #fff;
              padding: 0 15px;
            }
          }
        }
      }
    }
    div.UphotoShowpage {
      display: flex;
      justify-content: center;
    }
  }
}

div.addyzbg {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 100;
}

div.addyz {
  width: 500px;
  background: #fff;
  border-radius: 4px;
  z-index: 101;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 0 20px 20px;
  box-sizing: border-box;
}

div.addyz div.hd {
  height: 40px;
  text-align: center;
  border-radius: 4px;
}

div.addyz div.hd h3 {
  display: inline-block;
  height: 40px;
  line-height: 40px;
  font-size: 18px;
}

div.addyz div.hd button {
  display: block;
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 22px;
  color: #888;
  background: none;
  border: 0;
}

div.addyz div.addyz_bd div.title {
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  color: #666;
  margin-top: 20px;
}

div.addyz div.addyz_bd div.title span {
  font-size: 14px;
  color: #f00;
}

div.addyz div.addyz_bd div.entry input[type="text"] {
  display: block;
  width: 100%;
  height: 40px;
  line-height: 40px;
  border-radius: 5px;
  margin-top: 10px;
  padding: 0 7px;
  box-sizing: border-box;
  border: 1px #ddd solid;
}

div.addyz div.addyz_bd div.entry textarea {
  display: block;
  width: 100%;
  height: 100px;
  line-height: 40px;
  border-radius: 5px;
  margin-top: 10px;
  padding: 0 7px;
  box-sizing: border-box;
  border: 1px #ddd solid;
}

div.addyz div.addyz_bd div.tag {
  position: relative;
}

div.addyz div.addyz_bd div.tag span {
  display: inline-block;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
  position: absolute;
  top: 0;
  right: 0;
  color: #999;
}

div.addyz div.addyz_bd div.entry label {
  display: inline-block;
  height: 40px;
  line-height: 40px;
  padding-right: 10px;
}

div.addyz div.addyz_bd div.entry label input {
  display: inline-block;
  width: 16px;
  height: 16px;
  vertical-align: middle;
  margin-top: -2px;
}

div.addyz div.addyz_bd div.entry label span {
  display: inline-block;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  padding: 0 5px;
}

div.addyzfoot {
  padding: 15px;
  padding-top: 0;
}

div.addyzfoot button {
  display: inline-block;
  margin-left: 10px;
  height: 30px;
  line-height: 30px;
  padding: 0 15px;
  font-size: 14px;
  background: #fff;
  border: 1px #c00 solid;
  border-radius: 4px;
  color: #f00;
}

div.addyzfoot button.sure {
  background: #c00;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/ucenter/UPhotoShow.vue